import { createSlotRecipe } from './runtime.js';

const tableSelectionBarConfig = {"name":"tableSelectionBar","className":"table-selection-bar","slots":["root","icon","text"]}

export const tableSelectionBar = /* @__PURE__ */ createSlotRecipe(tableSelectionBarConfig)